import React, {Component} from 'react';
import { logout } from 'modules/auth/actions';
import { store } from 'app/store';

export class Logout extends Component {

    componentWillMount() {
        store.dispatch(logout());
    }

    componentWillUnmount() {
        window.location.reload(false);
    }

    render() {
        return <div>Logging out...</div>;
    }

}
